import React from 'react';
import { Typography } from 'antd';
// Helpers
import { formatEstateKey } from 'helpers/teams/cbTeamOwnershipTransfer.helpers';
// Types
import { EstateCount } from 'helpers/teams/cbTeamOwnershipTransfer.types';
// Styles
import styles from './EstateList.module.scss';

const { Text } = Typography;

type EstateListProps = {
  estate: EstateCount[];
};

const EstateList = ({ estate }: EstateListProps): JSX.Element => (
  <div className={styles.estateList}>
    {estate.map((item) => (
      <span key={item.key} className={styles.estateChip}>
        <Text>
          {formatEstateKey(item.key)}: <Text strong>{item.count}</Text>
        </Text>
      </span>
    ))}
  </div>
);

export default EstateList;
